import {zDateTime, zNumberToString} from '@brunata-angular/util';
import {z} from 'zod';

export const emailLogDataSchema = z
    .object({
        emaillogid: zNumberToString,
        senttime: zDateTime.nullable(),
        toaddresses: z.string().nullable(),
        ccaddresses: z.string().nullable(),
        bccaddresses: z.string().nullable().optional(),
        subject: z.string().nullable(),
        textcontent: z.string().nullable(),
        htmlcontent: z.string().nullable(),
        attachments: z.array(z.string()).nullable(),
        extradata: z.string().nullable(),
        sentstatus: z.string().nullable(),
    })
    .transform(data => ({
        emailLogId: data.emaillogid,
        sentTime: data.senttime,
        toAddresses: data.toaddresses,
        ccAddresses: data.ccaddresses,
        bccAddresses: data.bccaddresses,
        subject: data.subject,
        textContent: data.textcontent,
        htmlContent: data.htmlcontent,
        extraData: data.extradata,
        sentStatus: data.sentstatus,
    }));

export type EmailLogData = z.infer<typeof emailLogDataSchema>;
